import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import City from './City';

// styles
import './CityList.scss';

const orderCities = cityList =>
  cityList.sort((a, b) => b.relevance - a.relevance);

const CityList = props => {
  const { cities, isCollapsed } = props;
  const classesWrapper = classNames('city-list__wrapper', {
    'city-list__wrapper--collapsed': isCollapsed
  });

  return (
    <div className={classesWrapper}>
      {orderCities(cities).map(city => (
        <City
          key={`${city.id}`}
          id={city.id}
          numberOfRentableUnits={city.numberOfRentableUnits}
          country={city.country.countryId.toLowerCase()}
        />
      ))}
    </div>
  );
};

CityList.propTypes = {
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      numberOfRentableUnits: PropTypes.number,
      country: PropTypes.string
    })
  ).isRequired,
  isCollapsed: PropTypes.bool
};

CityList.defaultProps = {
  isCollapsed: false
};

export default CityList;
